// Generated by Melange

import * as Belt__Belt_List from "melange.belt/belt_List.js";
import * as Buhta_components__Text from "../../../../../packages/components/src/html/Text.js";
import * as Cn from "../../../../../vendored/classnames/Cn.js";
import * as JsxRuntime from "react/jsx-runtime";

const _map = {"left":"left","center":"center","right":"right"};

function titleAlignToJs(param) {
  return param;
}

function titleAlignFromJs(param) {
  return _map[param];
}

function panel(shadowed, bordered, rounded, scrollable) {
  return Cn.fromList({
    hd: "bg-white flex flex-col items-stretch rounded",
    tl: {
      hd: Cn.on("rounded-md", rounded),
      tl: {
        hd: Cn.on("h-full", scrollable),
        tl: {
          hd: Cn.on("shadow-card", shadowed),
          tl: {
            hd: Cn.on("border border-gray-main", bordered),
            tl: /* [] */ 0
          }
        }
      }
    }
  });
}

function toolbar(titleAlign) {
  return Cn.fromList({
    hd: "grid h-14 gap-x-4 items-center py-3 px-6 border-b border-gray-main",
    tl: {
      hd: titleAlign === "right" ? "grid-cols-1fr-2auto" : (
          titleAlign === "center" ? "grid-cols-1-auto-1" : "grid-cols-2auto-1fr"
        ),
      tl: /* [] */ 0
    }
  });
}

function content(scrollable) {
  return Cn.fromList({
    hd: "flex flex-col grow",
    tl: {
      hd: Cn.on("overflow-auto flex-1", scrollable),
      tl: /* [] */ 0
    }
  });
}

const Styles = {
  panel: panel,
  toolbar: toolbar,
  content: content
};

function Panel(Props) {
  let title = Props.title;
  let titleAlignOpt = Props.titleAlign;
  let textSizeOpt = Props.textSize;
  let leftActionsOpt = Props.leftActions;
  let rightActionsOpt = Props.rightActions;
  let contentScrollableOpt = Props.contentScrollable;
  let shadowedOpt = Props.shadowed;
  let borderedOpt = Props.bordered;
  let roundedOpt = Props.rounded;
  let className = Props.className;
  let children = Props.children;
  const titleAlign = titleAlignOpt !== undefined ? titleAlignOpt : "center";
  const textSize = textSizeOpt !== undefined ? textSizeOpt : "l";
  const leftActions = leftActionsOpt !== undefined ? leftActionsOpt : /* [] */ 0;
  const rightActions = rightActionsOpt !== undefined ? rightActionsOpt : /* [] */ 0;
  const contentScrollable = contentScrollableOpt !== undefined ? contentScrollableOpt : true;
  const shadowed = shadowedOpt !== undefined ? shadowedOpt : false;
  const bordered = borderedOpt !== undefined ? borderedOpt : false;
  const rounded = roundedOpt !== undefined ? roundedOpt : false;
  const className$1 = Cn.fromList({
    hd: panel(shadowed, bordered, rounded, contentScrollable),
    tl: {
      hd: Cn.take(className),
      tl: /* [] */ 0
    }
  });
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("div", {
            children: Belt__Belt_List.toArray(Belt__Belt_List.mapWithIndex(leftActions, (function (index, action) {
              const Key = "action-" + String(index);
              return JsxRuntime.jsx("div", {
                children: action
              }, Key);
            }))),
            className: "flex items-center justify-start space-x-4"
          }),
          textSize === "m" ? JsxRuntime.jsx(Buhta_components__Text.H4.make, {
              children: title
            }) : (
              textSize === "s" ? JsxRuntime.jsx(Buhta_components__Text.H5.make, {
                  children: title
                }) : JsxRuntime.jsx(Buhta_components__Text.H3.make, {
                  children: title
                })
            ),
          JsxRuntime.jsx("div", {
            children: Belt__Belt_List.toArray(Belt__Belt_List.mapWithIndex(rightActions, (function (index, action) {
              const Key = "action-" + String(index);
              return JsxRuntime.jsx("div", {
                children: action
              }, Key);
            }))),
            className: "flex items-center justify-end space-x-4"
          })
        ],
        className: toolbar(titleAlign)
      }),
      JsxRuntime.jsx("div", {
        children: children,
        className: content(contentScrollable)
      })
    ],
    className: className$1
  });
}

const make = Panel;

export {
  titleAlignToJs,
  titleAlignFromJs,
  Styles,
  make,
}
/* Buhta_components__Text Not a pure module */
